export enum AgentPoolStatusTypes {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}
